import { headerSearchBarFix, updateContentMargin, modifyFeatureLineup } from './utils/helpers';
import { setNavItemAttributes, updateMenuButton } from './utils/handleNavigation';

$(document).ready(function () {
  $('.generalmessage').prependTo('header');
  headerSearchBarFix('Search website');
  updateMenuButton();
  modifyFeatureLineup();
  updateContentMargin();

  $(globalThis).on('load', function () {
    setNavItemAttributes();
  });
});
